import PageParameters from "./PageParameters";
import SortParameters from "./SortParameters";
import { TicketStatus, Priority, TicketType } from "@/common/enum";

export default class TicketSearchingModel {
  public searchTerm!: string | null;
  public status!: TicketStatus | null;
  public priority!: Priority | null;
  public category!: TicketType | null;
  public companyId!: number | null;
  public pageParameters!: PageParameters;
  public sortParameters!: SortParameters;

  constructor() {
    this.searchTerm = null;
    this.status = null;
    this.priority = null;
    this.category = null;
    this.companyId = null;
    this.pageParameters = new PageParameters();
    this.sortParameters = new SortParameters();
  }
}
